module.exports = __webpack_public_path__ + "static/media/rt_logo_H_rgb.d6a081a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/rt_logo_H_rgb.png
// module id = 850
// module chunks = 0